import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";

class urlFieldForm extends React.Component {

    render() {
        return (
            <div className="col-md-9">
                <div className="form-group">
                    {this.props.presets.component_id ? <TextInput
                        name="url"
                        value={this.props.values.url}
                        label="Url"
                        disabled={this.props.generate}
                        saveChanges={this.props.setFieldValue}
                        {...this.props.getFieldProps("url")}
                    /> : <div className="form-group">
                        <label className="control-label">Url</label>
                        <div className="form-control">Kérlek mentsd el az url létrehozásához!</div>
                    </div>}
                </div>
            </div>
        );
    }
}

export default createForm(urlFieldForm);
